var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Popover, IconButton, Typography } from "@mui/material";
import { combineSxProps } from "../../Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { faAngleUp } from "@fortawesome/pro-regular-svg-icons/faAngleUp";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { palette } from "../../Theme";
const buttonSxProps = (hasValue) => (Object.assign({ ".MuiButton-endIcon": {
        width: "unset",
        "& > div": {
            gap: 0
        }
    } }, (hasValue ? {
    color: theme => theme.palette.primary.main
} : {
    color: theme => theme.palette.action.active,
    border: (theme) => `1px solid ${theme.palette.grey[200]}`,
    "&:hover": {
        backgroundColor: theme => theme.palette.grey[100],
        border: (theme) => `1px solid ${theme.palette.grey[200]}`
    },
    "&:focus": {
        border: (theme) => `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: theme => theme.palette.grey[200]
    }
})));
const popoverTitleSxProps = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px"
};
const clearButtonSxProps = {
    color: "inherit"
};
export const Filter = (props) => {
    const { anchorEl, setAnchorEl, placeholderValue, selectedValue, onClear, popoverTitle, PopoverProps, sx, children } = props, buttonProps = __rest(props, ["anchorEl", "setAnchorEl", "placeholderValue", "selectedValue", "onClear", "popoverTitle", "PopoverProps", "sx", "children"]);
    const hasValue = !!selectedValue;
    const open = Boolean(anchorEl);
    const angleIcon = (_jsx(FontAwesomeIcon, { icon: open ? faAngleUp : faAngleDown }));
    const clearButton = (_jsx(IconButton, { sx: clearButtonSxProps, size: "small", onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
        }, children: _jsx(FontAwesomeIcon, { icon: faTimes, style: { width: "12px", height: "12px" } }) }));
    const endIcon = !hasValue ? angleIcon : (_jsxs(Box, { sx: { display: "flex", gap: "4px", alignItems: "center" }, children: [clearButton, angleIcon] }));
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ sx: combineSxProps(buttonSxProps(hasValue), sx), variant: "outlined", onClick: (e) => setAnchorEl(e.currentTarget), endIcon: endIcon }, buttonProps, { children: _jsx(Typography, { variant: "body2", children: selectedValue !== null && selectedValue !== void 0 ? selectedValue : placeholderValue }) })), _jsxs(Popover, Object.assign({ open: open, anchorEl: anchorEl, onClose: () => setAnchorEl(null), anchorOrigin: {
                    horizontal: "left",
                    vertical: 32 + 8 //32 is the height of the button, 8 is margin
                } }, PopoverProps, { children: [_jsxs(Box, { sx: popoverTitleSxProps, children: [_jsxs(Typography, { variant: "subtitle1", children: [" ", popoverTitle, " "] }), _jsx(IconButton, { onClick: () => setAnchorEl(null), children: _jsx(FontAwesomeIcon, { icon: faTimes, color: palette.action.active, style: { width: "16px", height: "16px" } }) })] }), children] }))] }));
};
//# sourceMappingURL=Filter.js.map